export const UPDATE_LOCATION_SELECT_OPTIONS = "UPDATE_LOCATION_SELECT_OPTIONS";
export const UPDATE_LOCATION_INFO = "UPDATE_LOCATION_INFO";
export const UPDATE_VEHICLE_INFO_OPTIONS = 'UPDATE_VEHICLE_INFO_OPTIONS';
export const UPDATE_VEHICLE_INFO = "UPDATE_VEHICLE_INFO";
export const UPDATE_TRANSACTION_INFO = "UPDATE_TRANSACTION_INFO";
export const UPDATE_FIRST_BUYER_INFO = "UPDATE_FIRST_BUYER_INFO";
export const UPDATE_SECOND_BUYER_INFO = "UPDATE_SECOND_BUYER_INFO";
export const UPDATE_FIRST_SELLER_INFO = "UPDATE_FIRST_SELLER_INFO";
export const UPDATE_SECOND_SELLER_INFO = "UPDATE_SECOND_SELLER_INFO";
export const UPDATE_INSURANCE_INFO = "UPDATE_INSURANCE_INFO";
export const UPDATE_LIEN_HOLDER_INFO = "UPDATE_LIEN_HOLDER_INFO";
export const UPDATE_FIRST_OWNER_INFO = "UPDATE_FIRST_OWNER_INFO";
export const UPDATE_SECOND_OWNER_INFO = "UPDATE_SECOND_OWNER_INFO";
export const CLEAR_FORM_DATA = "CLEAR_FORM_DATA";
// Dispatched by the "Clear Form" button on the input pages. Distinct from
// CLEAR_FORM_DATA (logout / post-submit) because it deliberately keeps
// transactionInfo.transactionType -- see the reducer for why.
export const CLEAR_FORM_INPUTS = "CLEAR_FORM_INPUTS";
export const SET_SELECTED_CARDS = 'SET_SELECTED_CARDS';
export const GET_LIEN_HOLDER_INFO_SUCCESS = 'GET_LIEN_HOLDER_INFO_SUCCESS';
export const GET_LIEN_HOLDER_INFO_FAILED = 'GET_LIEN_HOLDER_INFO_FAILED';
